import { render, staticRenderFns } from "./OntslagbriefForm.vue?vue&type=template&id=f61d51c2"
import script from "./OntslagbriefForm.vue?vue&type=script&lang=js"
export * from "./OntslagbriefForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports